import styled from 'styled-components'

export const ErrorMessage = styled.div`
  font-family: ${(props) => props.theme.fontFamily};
  color: ${({ theme }) => theme.errorColour};
  font-size: 12px;
  text-align: left;
`
